import React, { useContext } from 'react';
import { getLanguagesSet } from "../constants";
import { determineTranslationType } from "../helpers";
import { PageNavigatorContext } from "../PageNavigator";
import { TextBase } from "../../internal/TextBase";
export var Results = function Results() {
  var _useContext = useContext(PageNavigatorContext),
      locale = _useContext.locale,
      totalItems = _useContext.totalItems;

  var _getLanguagesSet = getLanguagesSet(locale),
      translations = _getLanguagesSet.translations;

  var foundWord = determineTranslationType(translations.titleFound, totalItems);
  var resultWord = determineTranslationType(translations.titleResults, totalItems);
  return /*#__PURE__*/React.createElement(TextBase, {
    color: "N80"
  }, foundWord, " ", totalItems, " ", resultWord);
};